import React, { useMemo, useState } from "react";
import { Form, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_SUBCONTRACTOR_CURSOR } from "graphql/query/subcontractor-gql";
import Icons from "components/icons";
import { cursorPagination } from "components/service";
import { useDebounce, useTranslation } from "components/use-hooks";


const StaffWorkersSubcontractorSelect = ({
    form,
    name = "subcontractor_id",
    selected = false,
    onChange = () => {},
}) => {
    const [ searchText, setSearchText ] = useState("");
    const translations = useTranslation();
    const debouncedSearchText = useDebounce(searchText);
    const { data, loading, fetchMore } = useQuery(GET_SUBCONTRACTOR_CURSOR, {
        variables: {
            text: debouncedSearchText,
            first: 25,
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
    });
    const { nodes, onPopupScroll } = cursorPagination({
        model: "subcontractorsCursor",
        data,
        loading,
        fetchMore,
    });
    const options = useMemo(() => (
        [ ...new Map(nodes.map((item) => [ String(item.value), {
            value: String(item.value),
            label: item.label,
        } ])).values() ]
    ), [ nodes ]);
    const subcontractorLabel = translations[ "STAFF_MANAGEMENT.Filter_Subcontractor" ] || "Subcontractor";

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ subcontractorLabel }
                clearIcon={ <CloseOutlined /> }
                showArrow
                showSearch
                className={ `staff-workers-filter__subcontractor${
                    selected ? " staff-workers-filter__subcontractor--chosen staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-workers-filter__dropdown"
                filterOption={ false }
                loading={ loading }
                options={ options }
                placeholder={ subcontractorLabel }
                suffixIcon={ selected ? null : <Icons.Arrow /> }
                onPopupScroll={ onPopupScroll }
                onSearch={ setSearchText }
                onChange={ (value) => {
                    form.setFieldsValue({ [ name ]: value });
                    onChange(value);
                } } />
        </Form.Item>
    );
};

export default StaffWorkersSubcontractorSelect;
